import React from 'react';
import { observer } from 'mobx-react-lite';
import { Container } from '@pixi/react';
import BoostedJackpotWinPopupView from './boostedJackpotWinPopupView';
import { boostedJackpotStore } from '../../../../store/boostedJackpotStore';

const BoostedJackpotWinPopup = observer(({ containerConfigBoostedJackpotWinPopup }) => {
  const {
    setIsBoostedJackpotWinPopup,
    isBoostedJackpotWinPopup,
    spinWheelWinAmount,
    setIsWheel,
    setSpinWheelWinAmount,
  } = boostedJackpotStore;

  if (!isBoostedJackpotWinPopup) {
    return null;
  }
  return (
    <Container {...containerConfigBoostedJackpotWinPopup}>
      <BoostedJackpotWinPopupView
        setIsWheel={setIsWheel}
        spinWheelWinAmount={spinWheelWinAmount}
        setSpinWheelWinAmount={setSpinWheelWinAmount}
        setIsBoostedJackpotWinPopup={setIsBoostedJackpotWinPopup}
      />
    </Container>
  );
});

export default BoostedJackpotWinPopup;
